export default __webpack_public_path__ + "static/home-care-science-88726b81a7223527227787f1ba7b8173.webm";